<template>
	<div
		class="metric"
		:class="{ 'metric--accent': accent }">
		<div class="metric__header">
			<div class="metric__icon-container">
				<i
					class="metric__icon"
					:class="icon" />
			</div>
			<div class="metric__title">{{ label }}</div>
		</div>
		<div class="metric__value">{{ value }}</div>
		<div class="metric__label metric__label--small">{{ sublabel }}</div>
	</div>
</template>

<script setup lang="ts">
defineProps<{
	icon: string
	label: string
	sublabel: string
	value: string | number
	accent?: boolean
}>()
</script>

<style scoped lang="scss">
.metric {
	display: flex;
	align-items: start;
	flex-direction: column;
	gap: 8px;
	background: var(--card-bg);
	border: 1px solid var(--border);
	border-radius: 8px;
	padding: 16px;
	/* Subtle inset look for default metrics */
	box-shadow:
		inset 0 1px 0 rgba(255, 255, 255, 0.04),
		inset 0 -6px 12px rgba(0, 0, 0, 0.18);

	.metric__header {
		display: flex;
		align-items: center;
		width: 100%;
		gap: 8px;
		margin-bottom: 32px;

		.metric__icon-container {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 30px;
			height: 30px;
			min-width: 30px;
			min-height: 30px;
			border-radius: 8px;
			background: rgba(238, 255, 1, 0.1);

			.metric__icon {
				color: var(--p-yellow-500);
			}
		}

		.metric__title {
			font-size: 16px;
			font-weight: 700;
		}
	}

	.metric__value {
		font-weight: 700;
		font-size: 22px;
	}

	.metric__label {
		color: var(--muted);
		font-size: 12px;
	}
}

/* Subtle, non-interactive emphasis */
/* Only keep text color emphasis on value */
.metric--accent .metric__value {
	color: var(--p-yellow-400);
}

.metric--accent .metric__title {
	color: var(--p-yellow-400);
}

/* Raised look for the highlighted metric */
.metric--accent {
	box-shadow: 0 8px 18px rgba(0, 0, 0, 0.24);
}
</style>
